module.exports = __webpack_public_path__ + "img/novidades-card-a-sorte.27604d0b.png";